import api from './index';
//
let exports = {};

//
exports.getHandoverManfPageList = function (postData, callback) {
    api.post('/servicer/handover/manf/list/get')
    .data(postData)
    .done(callback)
    .go();
};
// 获取-交接单信息
exports.getHandoverManfInfo = function (postData, callback) {
    api.post('/servicer/handover/manf/info/get')
    .data(postData)
    .done(callback)
    .go();
};

// 获取-交接单详情
exports.getHandoverManfDetail = function (postData, callback) {
    api.post('/servicer/handover/manf/detail/get')
    .data(postData)
    .done(callback)
    .go();
};

// 更新交接单
exports.updateServicerHandover = function (postData, callback) {
    api.post('/servicer/handover/manf/update/do')
    .data(postData)
    .done(callback)
    .go();
};

// 服务商交接单确认操作
exports.doAuditServicerHandoverManf = function (postData, callback) {
    api.post('/servicer/handover/manf/audit/do')
    .data(postData)
    .done(callback)
    .go();
};

// 开始交接单
exports.updateServicerHandoverManfForStart = function (postData, callback) {
    api.post('/servicer/handover/manf/update/for/start/do')
    .data(postData)
    .done(callback)
    .go();
};

// 撤回交接单
exports.resetStateHandoverManf = function (postData, callback) {
    api.post('/servicer/handover/manf/reset/state/do')
    .data(postData)
    .done(callback)
    .go();
};

// 获取服务商交接单项列表
exports.getServicerHandoverItemList = function (postData, callback) {
    api.get('/servicer/handover/item/list/get')
    .params(postData)
    .done(callback)
    .go();
};

// 交接成功
exports.updateServicerHandoverItemState = function (postData, callback) {
    api.post('/servicer/handover/item/state/update/do')
    .data(postData)
    .done(callback)
    .go();
};

// 配件交接成功
exports.updateServicerHandoverItemStateFinished = function (postData, callback) {
    api.post('/servicer/handover/item/state/finished/update/do')
    .data(postData)
    .done(callback)
    .go();
};

// 根据交接人id 生成交接单项列表
exports.getServicerHandoverItemListByStaffId = function (postData, callback) {
    api.post('/servicer/handover/manf/item/list/get')
    .data(postData)
    .done(callback)
    .go();
};

// 根据交接人id 生成交接单项列表
exports.getServicerHandoverDetailItemList = function (postData, callback) {
    api.post('/servicer/handover/detail/item/list/get')
    .data(postData)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/handover.js
// module id = 88
// module chunks = 1